import React, { Component } from 'react';

export class CameraControl extends Component {
    constructor(props) {
        super(props);
        this.state = {
            videoSrc: null
        };
        this.videoElement = null;
        this.canvasElement = null;
        this.handleVideo = this.handleVideo.bind(this);
    }
    componentDidMount() {
        navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia || navigator.oGetUserMedia;
        if (navigator.getUserMedia) {
            navigator.getUserMedia({ video: true }, this.handleVideo, this.videoError);
        }
    }
    handleVideo(stream) {
        var me = this;
        //this.setState({ videoSrc: window.URL.createObjectURL(stream) });
        this.videoElement.srcObject = stream;
        this.videoElement.play();
        //setTimeout(function () { me.takePhoto(); }, 5000);
    }
    videoError() {
        var i = 0;
    }
    takePhoto(maxWidth, maxHeight) {
        const context = this.canvasElement.getContext('2d');
        this.resizeCanvas(context.canvas, this.videoElement.clientWidth, this.videoElement.clientHeight, maxWidth, maxHeight.height);
        context.drawImage(this.videoElement, 0, 0, context.canvas.width, context.canvas.height);
        var str = null;
        var str = context.canvas.toDataURL('image/jpeg');
        return str;
    }
    resizeCanvas(canvas, sourceWidth, sourceHeight, maxWidth, maxHeight) {
        //alert(sourceWidth + ', ' + sourceHeight);
        var sourceRatio = sourceHeight / sourceWidth;
        var destW = maxWidth;
        var destH = maxHeight;
        var destRatio = destH / destW;
        var dw = destW / sourceWidth;
        var dh = destH / sourceHeight;

        var nw = sourceWidth * dw;
        var nh = sourceHeight * dw;

        if (nh > destH) {
            nw = sourceWidth * dh;
            nh = sourceHeight * dh;
        }
        //alert(nw + ', ' + nh);

        var context = canvas.getContext('2d');
        context.canvas.width = nw;
        context.canvas.height = nh;
    }
    render() {
        return (
            <div>
                <div style={{ height: '13em', maxHeight: '13em' }}>
                    <video id="video" height="100%" className="cameraFrame" src={this.state.videoSrc} autoPlay="true" ref={(input) => { this.videoElement = input; }}></video>
                </div>
                <div style={{ height: '13em', maxHeight: '13em', display: 'none' }}>
                    <canvas id="canvas" height="100%" className="photoCard" ref={(input) => this.canvasElement = input} />
                </div>
            </div>
        );
    }
}